import React from 'react';
import type { CFSummary } from '../../types/campaignFinance';
import { fmtMoney } from '../../utils/campaignFinanceUtils';
import StatCard, { StatCardRow } from '../StatCard';

interface CFSummaryCardsProps {
  summary: CFSummary;
  /** Context line rendered under Total Raised (e.g. the active filter scope). */
  contextLabel?: string;
}

const CFSummaryCards: React.FC<CFSummaryCardsProps> = ({ summary, contextLabel }) => (
  <StatCardRow minTileWidth="11rem">
    <StatCard
      label="Total Raised"
      value={fmtMoney(summary.total, { compact: true })}
      variant="success"
      sublabel={contextLabel}
    />
    <StatCard label="Contributions" value={summary.count.toLocaleString()} />
    <StatCard label="Unique Contributors" value={summary.contributors.toLocaleString()} />
    <StatCard label="Median Gift" value={fmtMoney(summary.median)} variant="info" />
  </StatCardRow>
);

export default CFSummaryCards;
